
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField,
    Tabs,
    Tab,
    Paper,
    Tooltip,
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel} from '../../models/models';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';
import DOMPurify from "dompurify"


export const HtmlFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: string,
  onChange: (value: string, layoutField: LayoutFieldModel) => void,
}> = ( {
  layoutField,
  value,
  onChange
}) => {

  const theme = useTheme();


  const handleChange = (event: any) => {
    const value = event.target.value;

    onChange(value, layoutField);
  }

  const required = checkLayoutFieldRequirement(layoutField);

  const error = () => {
    if(required &&
       (!value || value == "\"\"")){
         return true
       }
    return false
  };

  const [preview, setPreview] = useState<boolean>(false)

  return (
    <Box position="relative">
      {preview &&
        <Paper
          sx= {{
            p: 2,
            minHeight: 120,
            maxHeight: 247,
            overflowY: "auto",
            borderRadius: 3,
            textAlign: 'left',
            backgroundColor: 'white',
            color: theme.palette.text.primary
          }}
          variant="outlined"
        >

          <Typography
            variant="subtitle2"
            sx={{
              mb: 1,
              fontWeight: 500,
              color: theme.palette.text.secondary
            }}
          >
            {layoutField.ReferencedField_sys.Label_sys}
          </Typography>

          <Box
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value)}}
          />
        </Paper>
      }
      {!preview &&
        <TextField
           fullWidth
           error={error()}
           disabled={layoutField.AccessSetting_sys === 'read'}
           multiline={layoutField.ReferencedField_sys.VisibleLines_sys === null ? false : true}
           rows={layoutField.ReferencedField_sys.VisibleLines_sys === null ? 1 : layoutField.ReferencedField_sys.VisibleLines_sys}
           required={required}
           size="small"
           label={`${layoutField.ReferencedField_sys.Label_sys} (max. ${layoutField.ReferencedField_sys.Length_sys})`}
           variant="filled"
           value={value}
           onChange={(event) => handleChange(event)}
           helperText={layoutField.ReferencedField_sys.HelpText_sys}
           inputProps={{
             maxLength: layoutField.ReferencedField_sys.Length_sys,
           }}
        />
      }
      <Tooltip title={preview ? 'Edit HTML' : 'Preview HTML'} arrow>
        <IconButton
          size="small"
          onClick={() => setPreview(!preview)}
          sx={{
            position: "absolute",
            top: 8,
            right: 8
          }}
        >
          {preview ? (
            <EditIcon fontSize="small" />
          ) : (
            <VisibilityIcon fontSize="small"/>
          )}
        </IconButton>
      </Tooltip>
    </Box>
  )

};
